/**
 * Kreed Odisha Sports Excellence Program
 * React Application Entry Point
 * 
 * @author Vishal Thakur <vt9999.2025@gmail.com>
 * @description Main React application for Kreed Odisha sports platform
 * @version 1.0.0
 */

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ApplicationPage from './pages/ApplicationPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboard from './pages/AdminDashboard';
import ApplicationsManagementPage from './pages/ApplicationsManagementPage';
import ApplicationDetailsPage from './pages/ApplicationDetailsPage';
import AdminSettingsPage from './pages/AdminSettingsPage';
import ApplicationPrintPage from './pages/ApplicationPrintPage';
import CheckStatusPage from './pages/CheckStatusPage';
import ClassLoginPage from './pages/ClassLoginPage';
import ClassDashboardPage from './pages/ClassDashboardPage';
import InstructorLoginPage from './pages/InstructorLoginPage';
import InstructorDashboardPage from './pages/InstructorDashboardPage';
import './index.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/apply" element={<ApplicationPage />} />
          <Route path="/check-status" element={<CheckStatusPage />} />
          <Route path="/class" element={<ClassLoginPage />} />
          <Route path="/class/dashboard" element={<ClassDashboardPage />} />
          <Route path="/classes" element={<Navigate to="/class/dashboard" replace />} />
          <Route path="/classes/dashboard" element={<Navigate to="/class/dashboard" replace />} />
          <Route path="/instructor" element={<Navigate to="/instructor/dashboard" replace />} />
          <Route path="/instructor/login" element={<InstructorLoginPage />} />
          <Route path="/instructor/dashboard" element={<InstructorDashboardPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/applications" element={<ApplicationsManagementPage />} />
          <Route path="/admin/applications/:id" element={<ApplicationDetailsPage />} />
          <Route path="/admin/applications/:id/print" element={<ApplicationPrintPage />} />
          <Route path="/admin/settings" element={<AdminSettingsPage />} />
          <Route path="/admin/attendance" element={<AdminSettingsPage defaultTab="class-attendance" />} />
          <Route path="/admin/classes" element={<AdminSettingsPage defaultTab="class-attendance" />} />
          <Route path="/admin/videos" element={<AdminSettingsPage defaultTab="class-attendance" />} />
          <Route path="/admin/queries" element={<AdminSettingsPage defaultTab="weekly-queries" />} />
          <Route path="/admin/weekly-queries" element={<AdminSettingsPage defaultTab="weekly-queries" />} />
          <Route path="/admin/exams" element={<AdminSettingsPage defaultTab="exams-schedule" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
